import { render, staticRenderFns } from "./ControlConfig.vue?vue&type=template&id=373e1a15"
import script from "./ControlConfig.vue?vue&type=script&lang=js"
export * from "./ControlConfig.vue?vue&type=script&lang=js"
import style0 from "./ControlConfig.vue?vue&type=style&index=0&id=373e1a15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports